export const ATTRIBUTE_REGEX = /data-(signing|hellosign|template)-/g;

export const ATTRIBUTE_MAP = {
  dependencegroup: 'dependenceGroup',
};

export const allowedAttributes = [
  'data-template-field-type',
  'data-signing-dependencegroup-id',
  'data-signing-dependencegroup-parent-id',
  'data-signing-dependencegroup-requirement',
  'data-signing-id',
  'data-signing-dependencegroup-name',
  'data-hellosign-tag',
  'data-hellosign-required',
  'data-hellosign-signer',
  'data-signing-role-engine-config',
  'data-signing-use-poa-verbiage',
  'data-signing-display-signature-line',
  'data-signing-authorized-signer-mode',
  'data-signing-authorized-signer-user-id',
  'data-signing-security-group-id',
];
